import { OrderPaymentCardCreationDto } from './order-payment-card.dto';

export class LaminatedCardPaymentCreationDto extends OrderPaymentCardCreationDto {}
